import api from "@/services/api/exercise/api-chapter-categories"
import ItemModel from "./models/ChapterCategoryModel"

export default class GraduatesService {
  constructor(authSvc) {
    this.authSvc = authSvc
  }

  async list(query) {
    try {
      const res = await api.list(query)
      if(!res) throw new Error('Something went wrong and list is not loading. Please, reload page or try again later.')
      return {
        results: res.map(item => new ItemModel(item)),
        pagination: {
          count: res.count,
        }
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async create(model) {
    try {
      const createApiData = model.getApiData();
      console.log('createApiData', {...createApiData});
      return await api.create(model.getApiData())
    } catch (error) {
      return Promise.reject(error) 
    }
  }

  async sort(ids) {
    try {
      return await api.sort(ids)
    } catch (error) {
      return Promise.reject(error) 
    }
  }

  async find(ID) {
    try {
      return await api.find(ID)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async put(ID, model) {
    try {
      return await api.put(ID, model.getApiData())
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async remove(item) {
    try {
      return await api.remove(item.id)
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
